import React from "react"
import Layout from "../components/layout"
import { graphql, Link } from "gatsby"
import BlogCategories from "../components/blog-categorys"
import Seo from "../components/seo"
import Share from "../components/share"
import { GatsbyImage, getImage } from "gatsby-plugin-image"

import "@wordpress/block-library/build-style/style.css"
import "@wordpress/block-library/build-style/theme.css"

export default function PostTemplate({ data }) {
  const post = data.allWpPost.nodes[0]
  const image = post.featuredImage?.node?.sourceUrl
    ? post.featuredImage?.node?.sourceUrl
    : null
  const featured = post.featuredImage
    ? getImage(post.featuredImage.node.xl)
    : null
  return (
    <Layout current={post}>
      <Seo
        title={post.title}
        description={post.excerpt.replace(/(<([^>]+)>)/gi, "")}
        article={true}
        url={`${process.env.GATSBY_SITE_URL}/${post.slug}/`}
        image={
          post.featuredImage?.node?.sourceUrl
            ? post.featuredImage?.node?.sourceUrl
            : null
        }
      />
      <div>
        <header className="bg-white dark:bg-gray-900 dark:text-white ">
          <h1 className="text-3xl lg:text-8xl text-gray-900 dark:text-white mb-8">
            {post.title}
          </h1>
        </header>
        {featured && (
          <GatsbyImage
            transformOptions={{ fit: "COVER", cropFocus: "ATTENTION" }}
            aspectRatio={1 / 1}
            image={featured}
            alt={post.title}
          />
        )}
        <div className={"mb-8"}>
          <BlogCategories post={post} />
          <div className={"mt-4 text-sm"}>
            <span className={"mr-4"}>Posted On:</span>
            {post.readableDate}
          </div>
        </div>
        <div
          className={"article-content- article-content mb-8"}
          dangerouslySetInnerHTML={{ __html: post.content }}
        />
      </div>
      <div className={"w-full mt-8 mb-4"}>
        <Share
          post={post}
          img={image}
          customShareTitle={`Stories for Kids - Read ${post.title}`}
        />
      </div>
      <div className={"mb-8"}>
        <BlogCategories post={post} />
      </div>
      <p>
        <Link to={"/blog"} className={"font-bold"}>
          Return to our blog
        </Link>
      </p>
    </Layout>
  )
}
export const query = graphql`
  query ($slug: String!) {
    allWpPost(filter: { slug: { eq: $slug } }) {
      nodes {
        ...post
      }
    }
  }
`
